import { getQueryStringParameter } from "owa-querystring";

export function getInitialFoldersCount(): string {
    const foldersCount: string | undefined = getQueryStringParameter("initialfolders");
    return foldersCount;
}
